<template>
    <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
      <div class="modal-dialog modal-xl" role="document">
        <form @submit.prevent="submitForm" class="form">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ $t('events.creation') }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor" />
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor" />
                    </svg>
                  </span>
              </div>
            </div>
  
            <div class="modal-body">
              <RequiredText></RequiredText>

              <div class="row">
                <div class="col-12 col-md-7 col-lg-7">
                  <div class="row">
                    <Input
                      container-class="col-12 col-md-6 col-lg-6 form-group mb-5"
                      :name="`event_title_`+id"
                      type="text"
                      :label="$t('events.name_event')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      size="lg"
                      :isRequired="true" 
                      v-model="formCreateData.title"
                      :placeholder="$t('events.name_event_placeholder')"
                    />

                    <Input
                      container-class="col-12 col-md-6 col-lg-6 form-group mb-5"
                      :name="`event_location_`+id"
                      type="text"
                      :label="$t('events.place_event')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      size="lg"
                      :isRequired="true" 
                      v-model="formCreateData.place"
                      :placeholder="$t('events.place_event_placeholder')"
                    />
                  </div>

                  <CKEditor
                    labelClass="form-label fs-6 text-black"
                    :label="$t('events.description')"
                    :id="`event_description_`+id"
                    :required="true"
                    :content="formCreateData.description"
                    @text="setDescription"
                  />

                  <CustomSelect2
                    :parent-id="'#'+id"
                    container-class="form-group col-12 col-md-12 mt-5"
                    :multiple="false"
                    :show-search="true"
                    :selectClass="'form-select form-control-sm form-select-solid'"
                    :name="`time_zone_id_`+id"
                    :isRequired="true"
                    :label="$t('events.gmt')"
                    labelClass="form-label fs-6 text-black"
                    :placeholder-text="$t('events.gmt_placeholder')"
                    v-model="formCreateData.timezone_id"
                    :IsInputGroup="true"
                  >
                    <option v-for="(timeZone, index) in timeZones" :key="index" :value="timeZone.id">
                      ({{timeZone?.diff_from_gtm}}) {{ timeZone.name }}
                    </option>
                    <template #custom>
                      <div class="icon-wrapper">
                        <i class="fas fa-globe text-primary" ></i>
                      </div>
                    </template>
                  </CustomSelect2>

                  <div class="row mt-5 pt-5" style="border-top: 1px solid var(--bs-gray-200);">
                    <InputFileIcon
                        containerClass="col-12 mt-auto mb-5"
                        :name="`events-logo`"
                        :label="$t('events.logo')"
                        labelClass="form-label fs-6 text-black"
                        :inputClass="'form-control form-control-sm form-control-solid'"
                        :isRequired="false"
                        size="lg"
                        :placeholder="$t('events.logo_placeholder')"
                        v-model="formCreateData.logo"
                    />
                  </div>

                  <CheckboxInput
                    :label="$t('events.is_free')"
                    :is-required="false"
                    v-model="formCreateData.is_free"
                    :bottom="false"/>
                </div>

                <div class="col-12 col-md-5 col-lg-5">
                  <div class="bg-light p-5 rounded-2">
                    <h6 class="mb-5">{{ $t('events.select_dates_text') }}</h6>
                    <div class="d-flex justify-content-center align-items-center md-5">
                      <DatePikerInline 
                          name="date-picker-event-id"
                          dateFormat="dd-MM-yyyy"
                          @handleDateClick="addDate"
                          :selectDates="selectedDates"
                      />
                    </div>
                    <div class="mt-5 card shadow-sm" v-for="(day, index) in formCreateData.days" :key="index">
                      <div class="d-flex justify-content-between align-items-center px-5 py-2">
                        <div class="col-12 col-md-3 col-lg-3">
                          <span class="mb-5">{{ $t('events.day') }} {{ parseInt(index)+1 }}</span>
                          <h4 class="text-primary">{{day.date}}</h4>
                        </div>
                        <div class="d-flex justify-content-center align-items-center col-12 col-md-9 col-lg-9">
                          <div class="me-5 col-6">
                            <span class="mb-3">{{ $t('events.start_hour') }}</span>
                            <Input
                              :name="'start_hour_'+id"
                              type="time"
                              v-model="day.startHour"
                            />
                          </div>
                          <div class="col-6">
                            <span class="mb-3">{{ $t('events.end_hour') }}</span>
                            <Input
                              :name="'end_hour_'+id"
                              type="time"
                              v-model="day.endHour"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
              <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoadingEvent"></Button>
            </div>
          </div>
        </form>
      </div>
    </div>
</template>

<script setup>
    import {ref, defineProps, onMounted, computed} from 'vue'
    import CKEditor from "@/components/CKEditor.vue";
    import Button from "@/components/Button";
    import Input from "@/components/Input.vue";
    import {useStore} from "vuex";
    import InputFileIcon from "@/components/InputFileIcon"
    import CustomSelect2 from "@/components/CustomSelect2.vue";
    import RequiredText from "@/components/RequiredText.vue"
    import CheckboxInput from '@/components/CheckboxInput.vue';
    import DatePikerInline from '@/components/DatePikerInline.vue';

    const emits = defineEmits(["load"]);
    
    const props = defineProps({
        id: {
            type: String,
            required: true
        },
        form: {
            type: Object,
            default: {
              title: '',
              description: '',
              latitude: 0,
              longitude: 0,
              place: '', 
              logo: null,
              timezone_id: '',
              days: [],
              number_of_places: 0,
              is_free: false
            }
        }
    })
  
    const store = useStore()
    const isLoadingEvent  = ref(false)
    const formCreateData = ref(props.form)
    const selectedDates = ref([])

    const timeZones = computed(() => store.getters["appointments/getTimeZones"])
    
    function closeModal(){
      $('#'+props.id).modal('toggle')
      formCreateData.value = {}
      selectedDates.value = []
    }
    
    function setDescription(text) {
        formCreateData.value.description = text
    }

    function addDate(date) {
      const index = formCreateData.value.days?.findIndex(day => day.date === date);
      if (index !== -1) {
        formCreateData.value.days?.splice(index, 1);
      } else {
        const sortedDates = [...formCreateData.value.days, {
          date: date,
          startHour: '',
          endHour: ''
        }].sort((a, b) => {
          const d1 = new Date(a.date.split('-').reverse().join('-'));
          const d2 = new Date(b.date.split('-').reverse().join('-'));
          return d1 - d2;
        });

        formCreateData.value.days = sortedDates
      }
    }
    
    function submitForm() {
        isLoadingEvent.value = true;
        
        store
        .dispatch('events/createEvent', formCreateData.value)
        .then(() => {
            isLoadingEvent.value = false;
            emits("load");
            closeModal();
    
            window.toastr["success"](i18n.global.t('events.created_successfully'));
        })
        .catch((e) => {

            isLoadingEvent.value = false;
        });
    }

    onMounted(() => {
      store.dispatch('appointments/loadTimeZones')
      const root = document.documentElement;
      if(root) root.style.setProperty('--dp-menu-min-width', '420px');
    })
</script>

<style scoped>
  .icon-wrapper {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-wrapper i {
    position: relative;
    font-size: 1.5em;
  }

  .icon-wrapper .icon-text {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    color: white;
    margin-top: 8px;
  }
</style>